import { createSlice } from '@reduxjs/toolkit'

const holidayNoticeModalSlice = createSlice({
  name: 'holidayNoticeModalState',
  initialState: {
    open: false,
    disclaimers: [],
    currentIndex: 0,
    data: {
      title: 'Holiday Notice',
      message: '',
      callback: () => { }
    }
  },
  reducers: {
    setHolidayNoticeModalOpen: (state, action) => {
      state.open = action.payload
    },
    setHolidayNoticeModalData: (state, action) => {
      state.data = action.payload
    },
    setDisclaimers: (state, action) => {
      state.disclaimers = action.payload
      state.currentIndex = 0
      if (action.payload.length > 0) {
        state.data = action.payload[0]
      }
    },
    nextDisclaimer: (state) => {
      if (state.currentIndex < state.disclaimers.length - 1) {
        state.currentIndex += 1
        state.data = state.disclaimers[state.currentIndex]
      } else {
        state.open = false
        state.disclaimers = []
        state.currentIndex = 0
      }
    }
  }
})

export const {
  setHolidayNoticeModalOpen,
  setHolidayNoticeModalData,
  setDisclaimers,
  nextDisclaimer
} = holidayNoticeModalSlice.actions

export default holidayNoticeModalSlice.reducer

